<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
    max-width="35rem"
    persistent
  >
    <template v-slot:activator="{ on: dialog }">
      <v-list-item
        v-if="list === true"
        v-on="{ ...dialog }"
        v-show="getIsAdmin"
      >
        <v-list-item-icon>
          <v-icon small>fa-calendar-day</v-icon></v-list-item-icon
        >
        <v-list-item-title>Gabarits par défaut</v-list-item-title>
      </v-list-item>
      <v-btn v-else-if="helper === true" block v-on="{ ...dialog }">
        <v-icon small left>fa-calendar-day</v-icon>
        Configurer
      </v-btn>
      <v-btn
        v-else
        v-show="getIsAdmin"
        v-on="{ ...dialog }"
        :block="$vuetify.breakpoint.xsOnly"
      >
        <v-icon small left>fa-calendar-day</v-icon>
        Gabarits par défaut
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="px-1 pt-1">
        <v-row justify="space-between" no-gutters>
          <v-spacer></v-spacer>
          <v-btn small icon text @click="dialog = false" :disabled="loading">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-tabs v-model="tab">
          <v-tab>Matin</v-tab>
          <v-tab>Midi</v-tab>
          <v-tab>Soir</v-tab>
          <v-tab-item v-for="d in data" :key="d.period">
            <DefaultDailyPrepSlipFields
              ref="inputs"
              v-bind.sync="d"
              :valid.sync="valid"
              :loading="loading"
            ></DefaultDailyPrepSlipFields>
          </v-tab-item>
        </v-tabs>
        <v-progress-linear
          indeterminate
          color="primary"
          v-show="loading"
        ></v-progress-linear>
      </v-card-text>
      <v-card-actions>
        <v-row align="center" justify="space-between" no-gutters>
          <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            :small="!$vuetify.breakpoint.xsOnly"
            :outlined="$vuetify.breakpoint.xsOnly"
            :text="!$vuetify.breakpoint.xsOnly"
            @click="dialog = false"
            :disabled="loading"
          >
            Annuler
          </v-btn>
          <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            :small="!$vuetify.breakpoint.xsOnly"
            :class="{ 'mt-3': $vuetify.breakpoint.xsOnly }"
            color="success"
            :disabled="!valid || loading"
            @click="save"
          >
            Appliquer
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from "@/api";
import DefaultDailyPrepSlipFields from "./DefaultDailyPrepSlipFields";
import { mapGetters } from "vuex";
export default {
  name: "DefaultDailyPrepSlipEditor",
  components: { DefaultDailyPrepSlipFields },
  props: {
    list: {
      type: Boolean,
      default: false
    },
    helper: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getStoreId", "getIsAdmin", "getDefaultDailySetting"])
  },
  data() {
    return {
      tab: 0,
      loading: false,
      dialog: false,
      data: [
        {
          store: this.getStoreId,
          period: 0,
          monday: null,
          tuesday: null,
          wednesday: null,
          thursday: null,
          friday: null,
          saturday: null,
          sunday: null
        },
        {
          store: this.getStoreId,
          period: 1,
          monday: null,
          tuesday: null,
          wednesday: null,
          thursday: null,
          friday: null,
          saturday: null,
          sunday: null
        },
        {
          store: this.getStoreId,
          period: 2,
          monday: null,
          tuesday: null,
          wednesday: null,
          thursday: null,
          friday: null,
          saturday: null,
          sunday: null
        }
      ],
      valid: false
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        this.getDefaultDailySetting.forEach(x => {
          switch (x.period) {
            case 0:
              this.data[0] = x;
              break;
            case 1:
              this.data[1] = x;
              break;
            case 2:
              this.data[2] = x;
              break;
          }
        });
      } finally {
        this.loading = false;
      }
    },
    async save() {
      if (this.valid === true) {
        try {
          this.loading = true;
          const tasks = [];
          this.data.forEach(x => {
            const d = {
              ...x,
              store: this.getStoreId
            };
            if (d.id && d.id !== null) {
              tasks.push(this.$store.dispatch("updateDefaultDailySetting", d));
            } else {
              tasks.push(api.postDefaultDailyPreparationSlip(d));
            }
          });
          await Promise.all(tasks);
          this.dialog = false;
        } finally {
          this.loading = false;
        }
      }
    }
  },
  watch: {
    dialog(v) {
      if (v === true) {
        this.getData();
      }
    }
  }
};
</script>

<style></style>
